
import Component from '../../../assets/scripts/modules/component';

class IFrame extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.iframe = this.element.querySelector('iframe');

    if (!this.iframe || !this.iframe.getAttribute('data-src')) {
      return;
    }

    this.loadIFrame();

  }

  loadIFrame() {

    this.iframe.setAttribute('src', this.iframe.getAttribute('data-src'));
    this.iframe.removeAttribute('data-src');

  }

}

for (const element of document.querySelectorAll('.iframe')) {
  element.instance = new IFrame('iframe', element, { onDelayedLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/iframe/iframe.js